import React from 'react'
import PropTypes from 'prop-types'

const SettingsIcon = ({ style, width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <path
      fill="#FFF"
      fillRule="nonzero"
      d="M16.73 8.675c.078.01.148.05.2.113a.345.345 0 0 1 .07.215v2.026c0 .076-.025.15-.07.21a.28.28 0 0 1-.183.119l-1.686.253a5.815 5.815 0 0 1-.355.83c.212.305.537.725.975 1.26a.35.35 0 0 1 .091.227.302.302 0 0 1-.08.21c-.276.35-.577.68-.9.986-.438.43-.723.646-.856.646a.447.447 0 0 1-.237-.08l-1.26-.986a5.2 5.2 0 0 1-.829.344c-.056.57-.144 1.137-.264 1.698a.307.307 0 0 1-.328.253H8.993a.344.344 0 0 1-.22-.076.27.27 0 0 1-.103-.194l-.253-1.675a5.663 5.663 0 0 1-.819-.34l-1.286.976a.328.328 0 0 1-.453-.022 11.995 11.995 0 0 1-1.502-1.53.356.356 0 0 1 0-.42c.093-.13.248-.333.463-.61.215-.276.379-.49.49-.64a4.463 4.463 0 0 1-.372-.9L3.27 11.32a.285.285 0 0 1-.194-.113A.34.34 0 0 1 3 10.99V8.966a.35.35 0 0 1 .075-.21.275.275 0 0 1 .173-.12l1.696-.252c.09-.292.209-.573.355-.84a20.994 20.994 0 0 0-.974-1.262.34.34 0 0 1-.092-.22.383.383 0 0 1 .08-.21c.278-.346.58-.67.905-.97.442-.435.73-.652.862-.652.087.003.17.035.237.091l1.255.975c.266-.138.543-.253.829-.344.055-.57.143-1.137.264-1.698a.307.307 0 0 1 .328-.253h2.025a.344.344 0 0 1 .22.076.27.27 0 0 1 .103.194l.253 1.675c.281.092.555.205.818.34l1.293-.976a.296.296 0 0 1 .22-.08.35.35 0 0 1 .226.091 12.47 12.47 0 0 1 1.503 1.552.296.296 0 0 1 .064.2.35.35 0 0 1-.075.21c-.09.125-.244.326-.463.603-.219.276-.382.49-.49.641.15.287.274.586.371.894l1.67.254zm-5.506 2.575l.013-.004c.334-.324.52-.771.513-1.237a1.75 1.75 0 1 0-.526 1.241z"
    />
  </svg>
)

SettingsIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default SettingsIcon
